import { cards } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精选合集</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">按类型整理的漫画推荐合集，随时随地发现好作品</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card, index) => (
            <a
              key={card.id}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className={`group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/50 hover:border-primary-200/60 transition-all cursor-pointer ${
                index === 6 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                  {card.tag}
                </span>
                <span className="absolute top-3 right-3 px-2.5 py-1 bg-background-50/90 text-foreground-700 text-xs font-medium rounded-full">
                  {card.count}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{card.title}</h3>
                <p className="text-sm text-foreground-600">{card.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}